import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <img 
            src="/images/logo.png.png" 
            alt="Ayodhya Natural Dairy Logo" 
            className="logo-image"
          />
        </div>
        <button className="hamburger-menu" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        </button>
        {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <a href="#home" className="nav-link" onClick={closeMenu}>Home</a>
          <a href="#products" className="nav-link" onClick={closeMenu}>Products</a>
          <a href="#story" className="nav-link" onClick={closeMenu}>Story</a>
          <a href="#testimonials" className="nav-link" onClick={closeMenu}>Testimonials</a>
          <a href="#contact" className="nav-link" onClick={closeMenu}>Contact</a>
        </nav>
        <a href="#contact" className="contact-btn">Contact Us</a>
      </div>
    </header>
  );
};

export default Header;

